var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"porfolio"},[_c('div',{staticClass:"proyectos"},_vm._l((_vm.proyectos_filtered),function(proyecto,index){return _c('proyecto',{key:index,attrs:{"id":proyecto.nombre,"datos_proy":proyecto,"hover":proyecto.active},on:{"click":function($event){proyecto.active = !proyecto.active}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }